import { TFunction } from '@lyearn/i18n';
import { CopyIcon, Trash2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { QuizCreatorActionsEnum } from '@/modules/corporate/modules/quiz/views/QuizEditor/hooks/useQuizEditor/actions';
import { QuizCreatorQuestionError } from '@/modules/corporate/modules/quiz/views/QuizEditor/hooks/useQuizEditor/types';

const IGNORED_ERROR_TYPES = ['LyearnAINudge'];

export const getQuestionListItemActions = (
  t: TFunction,
  quizSections?: Array<{ _id: string; name?: string | null; order?: number | null }> | null,
): ActionMenuItemType[] => {
  const moveItems: ActionMenuItemType[] = [
    {
      id: 'move_to_section:null',
      label: t('QuizCreator:Sections.UnsectionedQuestions'),
      type: 'item',
    },
  ];

  (quizSections ?? [])
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .forEach((s) => {
      moveItems.push({
        id: `move_to_section:${s._id}`,
        label: s.name ?? t('QuizCreator:Sections.SectionName'),
        type: 'item',
      });
    });

  const items: ActionMenuItemType[] = [
    {
      id: 'move_to_section',
      label: t('QuizCreator:Sections.MoveToSection'),
      type: 'item',
      items: moveItems,
    },
    { type: 'divider' },
    {
      id: QuizCreatorActionsEnum.DuplicateQuestion,
      label: t('Common:Actions.Duplicate'),
      EndIcon: CopyIcon,
      type: 'item',
    },
    {
      id: QuizCreatorActionsEnum.RemoveQuestion,
      appearance: 'danger',
      label: t('Common:Actions.Remove'),
      EndIcon: Trash2Outline,
      type: 'item',
    },
  ];

  return items;
};

export const getHTMLTextContent = (html: string) => {
  const el = document.createElement('div');
  el.innerHTML = html;
  return el.textContent || el.innerText || '';
};

export const isErrorIgnorable = (error: QuizCreatorQuestionError) => {
  return IGNORED_ERROR_TYPES.includes(error.type);
};
